import React from "react";
import Buttons from "../components/Buttons/Buttons";
// import History from "../components/History/History";
import Profile from "../components/Profile/Profile";
import Sidebar from "../components/Sidebar/Sidebar";
import Statistics from "../components/Statistics/Statistics";

import "./home.scss";

export default function Home({
  userData,
  leagueData,
  matches,
  game,
  championsList,
  summoners,
  queueId,
}) {
  return (
    <div className="home">
      <Sidebar />
      <div className="rightone">
        {userData ? (
          <>
            <Profile userData={userData} />
            <Buttons />
            <Statistics
              leagueData={leagueData}
              matches={matches}
              game={game}
              queueId={queueId}
              championsList={championsList}
              userData={userData}
              summoners={summoners}
            />
          </>
        ) : (
          <div className="empty-user">
            <div className="text">
              Eğer hangi kullanıcıyı arayacağınızı bilmiyorsanız
              aşağıdaki kullanıcı adlarından birini arayabilirsiniz.
            </div>
            <br />
            <div className="userstext">
              Shay, Azorath, CoronaVyrus, Åyåyå, Launcess
            </div>
          </div>
        )}

        {/* <History
          matches={matches}
          game={game}
          championsList={championsList}
          userData={userData}
          summoners={summoners}
        /> */}
      </div>
    </div>
  );
}
